
import Section from "../Section.vue";

export default {
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      mediaUrl: this.$config.BASE_URL_RESOURCE,
      visible: false,
      data: [],
      awardSelected: {},
    };
  },

  // watch: {
  //   "$store.state.SchoolDetail.school_outstanding"(value) {
  //     if (value) {
  //       if (value.trophies) {
  //         this.data = value.trophies;
  //       }
  //     }
  //   },
  // },
  mounted() {
    const value = JSON.parse(
      JSON.stringify(this.$store.state.SchoolDetail.school_outstanding)
    );
    if (value.trophies) {
      this.data = value.trophies;
    }
  },
  methods: {
    showModal(index) {
      this.awardSelected = this.data[index];
      this.visible = true;
    },
    handleOk(e) {
      this.visible = false;
    },
    closeModalTrigger() {
      this.awardSelected = {};
    },
  },
  components: { Section },
};
